export default "__VITE_ASSET__CGvf$HDF__"